import styled from "styled-components";
import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";
import { css } from "styled-components";
import React from "react";

/**
 * ButtonText (span)
 */
export const ButtonText = ({...props}) => {
    return <ButtonTextInner {...props}>
        {props?.heading && <SeoLinkText>{props?.heading}</SeoLinkText>}
        {props.children}
    </ButtonTextInner>
}

const SeoLinkText = styled.span`
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
`;

const ButtonTextInner = styled.span.attrs(
  ({
    large,
    color,
    hide,
    forcedFontSize,
    forcedFontSizeSmall,
    forcedLineHeight,
    display,
    fontSize,
    opacity,
    theme,
    alignItems,
    transition = true,
    textTransform,
  }) => ({
    fontSize: fontSize ? fontSize : large ? "30px" : "18px",
    color: color ? color : undefined,
    display: display ? display : "inline-block",
    opacity: hide ? 0 : 1,
    forcedFontSize: forcedFontSize ? forcedFontSize : undefined,
    forcedFontSizeSmall: forcedFontSizeSmall ? forcedFontSizeSmall : undefined,
    forcedLineHeight: forcedLineHeight,
    alignItems: alignItems ? alignItems : undefined,
    transition: transition ? "0.2s ease" : undefined,
    textTransform: textTransform ? textTransform : undefined,
  })
)`
  font-family: ${({ theme }) => theme.font}; 
  font-weight: ${({ fontWeight }) => fontWeight};
  padding: ${({ padding }) => (padding ? padding : "0 0.5rem")};
  font-size: ${({ forcedFontSize, fontSize, forcedFontSizeSmall }) =>
    forcedFontSizeSmall
      ? forcedFontSizeSmall
      : forcedFontSize
      ? forcedFontSize
      : fontSize};
  line-height: ${({ forcedLineHeight }) =>
    forcedLineHeight ? forcedLineHeight : "1.5em"};
  display: ${({ display }) => display};
  opacity: ${({ opacity }) => opacity};
    ${({ color }) =>
            color &&
            css`
                color: ${({ color }) => color};
    `}
  ${({ transition }) =>
    transition &&
    css`
      transition: ${({ transition }) => transition};
    `}

  ${({ textTransform }) =>
    textTransform &&
    css`
      text-transform: ${({ textTransform }) => textTransform};
    `}


  ${({ alignItems }) =>
    alignItems &&
    css`
      align-items: ${({ alignItems }) => alignItems};
    `}

  ${media.greaterThan(breakpoints.ipad)`
		font-size: ${({ forcedFontSize, fontSize }) =>
      forcedFontSize ? forcedFontSize : fontSize};
	`}
  ${media.lessThan(breakpoints.mobile)`
	padding: ${({ paddingsmall }) => paddingsmall};
	`}


	${({ blur }) => (blur ? "filter: blur(2px);" : "")};
  &:hover {
    cursor: pointer;
  }
`;
